module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/badges_png/reward_badge_bronze_ghost-bb5a8e27026a0cd8f0bd3b4447f2ef46.png";